import { useEffect, useRef } from 'react';
import { useSession } from '../context/SessionContext/SessionContext';

const GlobalDialogListener = () => {
  const { pauseSession, resumeSession } = useSession();
  const openDialogsRef = useRef(0);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const openDialogs = document.querySelectorAll(
        '[data-state="open"][role="dialog"]'
      ).length;

      if (openDialogs > openDialogsRef.current) {
        pauseSession();
      }

      if (openDialogs === 0 && openDialogsRef.current > 0) {
        resumeSession();
      }

      openDialogsRef.current = openDialogs;
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['data-state'],
      childList: true,
    });

    return () => observer.disconnect();
  }, [pauseSession, resumeSession]);

  return null;
};

export default GlobalDialogListener;